import React from 'react'
import { useFormContext } from 'react-hook-form'
import { AnalyzerFormValues } from '../analyzerForm.types'
import ICSTextArea from '../../../../components/ICSTextArea/ICSTextArea'

interface Props {
  name: keyof AnalyzerFormValues
  label: string
  placeholder?: string
  rows?: number
}

const AnalyzerTextArea = (props: Props) => {
  const { control } = useFormContext<AnalyzerFormValues>()
  return <ICSTextArea {...props} control={control} />
}

export default AnalyzerTextArea
